import { useDispatch, useSelector } from 'react-redux';
import {
  addRedirectParam,
  loginToApp,
  registerAndLogin,
  resetRedirectParam,
} from 'services/store/auth/actions';
import {
  checkErrorSelector,
  checkLoadingSelector,
} from 'services/store/base/selectors';
import authActionNames from 'services/store/auth/actions/constants';
import type { StoreRootState } from 'services/store/types';

const useAuthStore = () => {
  const dispatch = useDispatch();
  const authStore = useSelector((store: StoreRootState) => store.auth);
  const baseStore = useSelector((store: StoreRootState) => store.base);
  return {
    authStore,
    addRedirectParam: (
      to: string,
      actionRequired: boolean,
      hash?: string,
      params?: Record<string, unknown>
    ) => {
      dispatch(addRedirectParam({ to, actionRequired, hash, params }));
    },
    resetRedirectParam: (): void => {
      dispatch(resetRedirectParam());
    },
    loginToApp: (): void => {
      dispatch(loginToApp());
    },
    registerAndLogin: (
      formData: {
        email: string;
        password: string;
        cloudflareToken: string;
      },
      consentPreference: {
        general: boolean;
      }
    ): void => {
      dispatch(registerAndLogin({ userData: formData, consentPreference }));
    },
    isLoginToAppLoading: checkLoadingSelector(baseStore, [
      authActionNames.LOGIN_TO_APP,
    ]),
    isRegisteringLoading: checkLoadingSelector(baseStore, [
      authActionNames.REGISTER_AND_LOGIN,
    ]),
    registerError: checkErrorSelector(baseStore, [
      authActionNames.REGISTER_AND_LOGIN,
    ]),
  };
};

export default useAuthStore;
